import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "../../../context/AuthContext";

const PAGE_SIZE = 25;

// "Assigned By Me" — every task the current user assigned to a direct
// report, paginated (plan §4.2 — the contract was fixed to be paginated
// BEFORE any client was built against it, so the web UI follows the exact
// same {data, hasMore} shape the mobile app already consumes).
const useAssignedByMe = (BASE_URL, currentInfinityCode) => {
  const [tasks, setTasks] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchPage = useCallback(
    async (targetPage, { append = false } = {}) => {
      if (!currentInfinityCode) return;
      setLoading(true);
      try {
        const response = await apiFetch(
          `${BASE_URL}/todos/assigned-by/${currentInfinityCode}?page=${targetPage}&limit=${PAGE_SIZE}`,
          { method: "GET" }
        );
        const data = await response.json();
        setTasks((prev) => (append ? [...prev, ...(data.data || [])] : data.data || []));
        setHasMore(Boolean(data.hasMore));
        setPage(targetPage);
      } catch (error) {
        console.error("Error fetching assigned-by-me tasks:", error);
      } finally {
        setLoading(false);
      }
    },
    [BASE_URL, currentInfinityCode]
  );

  useEffect(() => {
    fetchPage(1);
  }, [fetchPage]);

  const loadMore = () => {
    if (!loading && hasMore) fetchPage(page + 1, { append: true });
  };

  const refetch = () => fetchPage(1);

  // Reflect a mutation made elsewhere (e.g. cancelling from the detail modal)
  // without a full refetch.
  const patchLocal = (id, patch) => {
    setTasks((prev) => prev.map((t) => (t.id === id ? { ...t, ...patch } : t)));
  };

  return { tasks, loading, hasMore, loadMore, refetch, patchLocal };
};

export default useAssignedByMe;
